import { ReactNode } from 'react';
import { CardPaymentMethodFragment } from '@websky/graphql';

export type CardPaymentMethodWithUrl = CardPaymentMethodFragment & { height?: number; frameUrl?: string };

export enum PaymentType {
	Gpay = 'Gpay',
	Card = 'Card',
	Credit = 'Credit',
	Itransfer = 'Itransfer',
	Kaspi = 'Kaspi',
	Cash = 'Cash',
	Invoice = 'Invoice',
	Qiwi = 'Qiwi',
	Fps = 'Fps',
	Sbol = 'Sbol',
	Podeli = 'Podeli',
	FFPBonus = 'FFPBonus',
	UniQr = 'UniQr'
}

export interface PaymentPage {
	type: PaymentType;
	title: string;
	description?: string;
	content: ReactNode;
}
